export class StatusCandidato {
    static Inscrito = 'CCFC0378-35C7-4F99-8490-E6ED108630B8';
    static Convocado = '4A45BE05-8023-4E89-AD9F-908A6D9DB9F2';
    static ConvocadoPrazoExtra = 'C17E2137-CFD2-4D21-90DE-F01069F38747';
    static Reagendado = '9A5EAC9E-41E5-46EE-8C0D-123274654C5C';
    static DesclassificadoPelaUnidade = 'E8DCAB45-91EB-4098-BFF6-2F57EAA7A26B';
    static DesclassificadoNaoComparecimento = 'D214DE2C-3210-4755-9716-DF7C2D1F1D5F';
    static Aderido = '917CEDF9-BFA5-4A1E-9D42-9C76761A9179';
    static DesclassificadoPorOutroMotivo = 'EF2BC378-C6DE-4C74-BACC-F160BCED667E';
    static EncaminhadoRealizacaoExameToxicologico = '183A6E69-7BEE-4328-A5B5-7B22AEBC4DE5';
    static DesclassificadoExameToxicologico = '190C978C-BABF-41CB-B308-87CDD809B2EE';
    static ClassificadoExameToxicologico = 'D30AFB7E-478B-435D-8C56-3ACCAABA293A';
    static EncaminhadoRealizacaoExameMedicoPsicologico = 'C56785F0-6E14-4E4C-AD4E-9E0553B59298';
    static ReprovadoExameMedicoPsicologico = '09E02BBE-E6A0-44E9-8BBE-9FCAAA69643F';
    static ClassificadoExameMedicoPsicologico = 'BA91CBE0-7127-4BF9-B0DA-171DFC7A2F45';
    static EncaminhadoRealizacaoCursoPratico = '6EE0761E-9A05-4925-AC4E-9FB51A4BAB29';
    static ReprovadoCursoPratico = 'D2A37592-817F-432F-8EB0-F5FBAB3F3D68';
    static AprovadoCursoPratico = 'A3C5B5A4-A0B0-46A1-99D1-3E52B2014F36';
    static EncaminhadoRealizacaoProvaPratica = 'C79776B7-BF44-4478-B4CC-69ABC402BFCE';
    static ReprovadoProvaPratica = '73A62B28-E2A0-4415-8CA5-D2A13EA95279';
    static AprovadoProvaPratica = '424D2C6B-E948-4310-9D2E-A66937987ABC';
    static AprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros = '05806E40-2F7E-45C9-B633-45360559D9A0';
    static ReprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros = '0CB9FD37-B664-49CB-A73E-0C6A18D70D49';
    static AprovadoCursoPraticaDirecaoSimulada = '147794BD-98D1-4789-A455-BA0993CB72BB';
    static ReprovadoCursoPraticaDirecaoSimulada = '33DFBD87-FB48-4007-B247-07D7B73E247D';
    static Concluido = '9250D13D-470F-4352-A0F0-C09FD5195E1A';
    static AprovadoEscolaMotoristas =  '46F49E39-87BB-41C8-A8A7-370EDDD4892D';
    static ReprovadoEscolaMotoristas = '3057B495-2EFC-4458-9D18-4C911E8B94A6';
    static AprovadoCursoHomologado = '61A2055C-3C06-4664-8DB4-D9BD08FFAEE8';
    static ReprovadoCursoHomologado = 'AB5C94B8-93DB-4FAA-BBEE-EFC57D0E5DDB'
}



// WEBPACK FOOTER //
// ./src/app/models/statusCandidato.ts